






























































































































































import Vue from "vue";
import { getEventsPaymentOptions } from "@/modules/event/payment-options.service";
import { putSubscriptionWithGuestsAndAnswers } from '@/modules/event/subscription.service';
import { AnswerModel,GuestModel,SubscriptionModel } from '@/modules/event/subscription.input';

export default Vue.extend({
  name: "SubscriptionPaymentDetails",
  props: ["subscription", "eventId", "paymentOptions", "admin", "edition", "handleUpdate"],
  components: { },
  data: () => ({
    paymentOptionsData: [],
    subscriptionToUpdate: {} as Any,
    sendEmail: false,
    errorMessage: '', 
  }),
  async mounted() {
    this.subscriptionToUpdate = JSON.parse(JSON.stringify(this.subscription))

    if (this.paymentOptions && this.paymentOptions.length > 0) {
      this.paymentOptionsData = this.paymentOptions;
    } else {
      await getEventsPaymentOptions(this.eventId).then((res) => {
        if (res.data) {
          this.paymentOptionsData = res.data;
        } else if (res.error) {
          console.log(
            "Erreur. Impossible de récupérer les données pour le paiement."
          );
        }
      });
    }
  },
  computed: {
    paymentOptionLabel() {
      if (!this.subscriptionToUpdate.paymentOptionsId) return "";
      return (
        this.paymentOptionsData.find(
          (paymentOption) =>
            paymentOption.id === this.subscriptionToUpdate.paymentOptionsId
        )?.label || ""
      );
    },
    paymentStatusOptions() {
      return [
      { text: 'A traiter', value: 'TOPROCESS' },
      { text: 'En attente', value: 'PENDING' },
      { text: 'Payé', value: 'PAYED' },
      { text: 'Annulé', value: 'CANCELLED' },
      { text: 'Autre', value: 'OTHER' },
      ]
    },
  },
  methods: {
    changePaymentStatus(status: string){
      if (this.handleUpdate){
        this.subscriptionToUpdate.paymentStatus = status;
        this.subscriptionToUpdate.guests?.forEach(guest => {
          guest.paymentStatus = status
        })
      }else{
        this.$emit('paymentStatus',status)
      }
    },
    changePaymentRef(ref: string){
      if (this.handleUpdate){
        this.subscriptionToUpdate.paymentRef = ref;
        this.subscriptionToUpdate.guests?.forEach(guest => {
          guest.paymentRef = ref
        })
      }else {
        this.$emit('paymentRef',ref)
      }
    },
    async updateSubscription(){
      console.log('updating subcription', this.subscriptionToUpdate)
      const dataToSend: SubscriptionModel = {
        id: this.subscriptionToUpdate.id,
        email:  this.subscriptionToUpdate.email,
        phoneNumber: this.subscriptionToUpdate.phonenumber,
        firstName:  this.subscriptionToUpdate.firstName,
        lastName:  this.subscriptionToUpdate.lastName,
        eventId: this.subscriptionToUpdate.eventId,
        guests: this.subscriptionToUpdate.guests.map(guest => {
          return {
            id: guest.id,
            firstName: guest.firstName,
            lastName: guest.lastName,
            guestCategoryId: guest.guestCategoryId,
            paymentStatus: guest.paymentStatus,
            paymentRef: guest.paymentRef,
            paymentAmount: guest.paymentAmount,
            answers: guest.answers?.map(answer => {
              return {
                id: answer.id,
                answer: answer.answer,
                questionId: answer.questionId,
              } as AnswerModel
            })
          } as GuestModel
        }),
        checkedIn: this.subscriptionToUpdate.checkedIn,
        organization: this.subscriptionToUpdate.organization,
        paymentOptionsId: this.subscriptionToUpdate.paymentOptionsId,
        paymentStatus: this.subscriptionToUpdate.paymentStatus,
        paymentRef: this.subscriptionToUpdate.paymentRef,
        paymentAmount: this.subscriptionToUpdate.paymentAmount
      };
      console.log('dataToSend',dataToSend)
      await putSubscriptionWithGuestsAndAnswers(dataToSend, this.sendEmail).then(async res => {
          if(res.data) {
            this.$emit("updateSuccessfull");
            this.errorMessage = ""
            this.close(true)
          } else if(res.error) {
            this.errorMessage = "Erreur à la modification de l'inscription ! "
          }
        });
    },
    handleClick() {
      this.$emit("click");
    },
    close(reset: boolean) {
      if(reset) this.reset()
      this.handleClick();
    },
    reset(){
      this.paymentOptionsData = [];
      this.subscriptionToUpdate = {} as Any;
      this.sendEmail = false;
      this.errorMessage = '';
    }
  },
});
